// extracted by mini-css-extract-plugin
export var cancelButton = "_nw-5";
export var content = "_nw-3";
export var createButton = "_nw-6";
export var drawerContainer = "_nw-0";
export var footer = "_nw-2";
export var header = "_nw-1";
export var orderFormColumn = "_nw-4";